// extracted by mini-css-extract-plugin
module.exports = {"tab__wrapper":"styles_tab__wrapper__2yC4H","tabs":"styles_tabs__2hrU1","content":"styles_content__38zfP"};